import React from "react";

const wuduSteps = [
  {
    title: "1. Niyyah (Intention)",
    description: "Make the intention in your heart to perform wudu for prayer."
  },
  {
    title: "2. Bismillah",
    description: "Say 'Bismillah' (In the name of Allah) before starting."
  },
  {
    title: "3. Wash Hands",
    description: "Wash both hands up to the wrists three times."
  },
  {
    title: "4. Rinse Mouth",
    description: "Rinse your mouth three times."
  },
  {
    title: "5. Rinse Nose",
    description: "Sniff water into your nose and blow it out three times."
  },
  {
    title: "6. Wash Face",
    description: "Wash your face from forehead to chin and ear to ear three times."
  },
  {
    title: "7. Wash Arms",
    description: "Wash your right arm, then left, from fingertips to elbows three times each."
  },
  {
    title: "8. Wipe Head",
    description: "Wet your hands and wipe over your head once."
  },
  {
    title: "9. Wipe Ears",
    description: "Wipe the inside and outside of both ears with wet fingers."
  },
  {
    title: "10. Wash Feet",
    description: "Wash your right foot, then left, up to the ankles three times each."
  },
  {
    title: "11. Dua After Wudu",
    description: "Recite the dua: 'Ashhadu an la ilaha illallah wahdahu la sharika lahu wa ashhadu anna Muhammadan abduhu wa rasuluhu.'"
  }
];

function WuduLesson() {
  return (
    <div className="min-h-screen bg-blue-50 p-6">
      <h1 className="text-4xl font-extrabold text-center text-blue-700 mb-10 drop-shadow">
        Steps of Wudu (Ablution)
      </h1>
      <div className="flex justify-center mb-8">
        <div className="w-full max-w-2xl aspect-video">
          <iframe
            className="w-full h-full rounded-xl shadow-lg"
            src="https://www.youtube.com/embed/5fgJ-YNUJoI"
            title="How to Perform Wudu (Ablution)"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {wuduSteps.map((step, idx) => (
          <div
            key={idx}
            className="bg-white rounded-2xl shadow-xl p-6 text-center border-4 border-blue-200 hover:shadow-2xl transition"
          >
            <h2 className="text-2xl font-bold text-blue-600 mb-2">{step.title}</h2>
            <p className="text-lg text-gray-700">{step.description}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 text-center">
        <p className="text-xl text-gray-700">
          Completing wudu is essential for prayer. May Allah accept your worship! 🕊️
        </p>
      </div>
    </div>
  );
}

export default WuduLesson; 